// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"3f2b2e9d","138":"98ac99de","274":"6dcde820","402":"ccc0d6a9","431":"1214589a","634":"b52ea4fb","893":"2f1111ac","968":"ba5e145b"}[chunkId] + ".chunk.js";
};